import computeClassName from "../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

export default function IconClock({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path d="M7.84082 3.71222V8.33733L11.3691 11.5171" stroke="currentColor" strokeLinecap="round"/>
      <path d="M15.5734 8.20001C15.5734 12.34 12.2013 15.7 8.0367 15.7C3.87213 15.7 0.5 12.34 0.5 8.20001C0.5 4.06003 3.87213 0.700012 8.0367 0.700012C12.2013 0.700012 15.5734 4.06003 15.5734 8.20001Z" stroke="currentColor"/>
    </svg>
  );
}
